export default __webpack_public_path__ + "static/media/865.136f8437.gif";